import React from 'react';
import { IMultiUserInvitePopupProps } from './types';
import SimplePopup from '../SimplePopup';
import { Container, Image, PopupInviteBlock, PopupText, PopupTitle } from './styles';
import { EnumTheme } from '../../../constants/enums';
import productImageSrc from 'assets/images/products.png';
import { ThemeButton } from '../../ThemedButton';
import { useSelector } from 'react-redux';
import { getCurrentShop } from '../../../Modules/Shops/selectors';
import { getPopUpSnapPoint } from '../../../utils/helpers';

export const MultiUserInitPopup: React.FC<IMultiUserInvitePopupProps> = ({ isShow, onClose }) => {
  const curentShpop = useSelector(getCurrentShop);

  return (
    <SimplePopup show={isShow} close={onClose} snapPointToTop={getPopUpSnapPoint(340)}>
      <Container>
        <Image src={productImageSrc} />
        <PopupTitle>Собирайте вместе заказ из {curentShpop.name}</PopupTitle>
        <PopupInviteBlock>
          <PopupText>Добавьте всё необходимое. Оформить и оплатить заказ сможет только владелец корзины.</PopupText>
          <ThemeButton use={EnumTheme.main} onClick={onClose}>
            За покупками
          </ThemeButton>
        </PopupInviteBlock>
      </Container>
    </SimplePopup>
  );
};
